export const PROPS_SPORTS_LIST = [
  { value: 'americanfootball_nfl', label: 'NFL', enabled: true },
  { value: 'basketball_nba', label: 'NBA', enabled: true },
  { value: 'baseball_mlb', label: 'MLB', enabled: true },
];

export const NBA_PROP_MARKETS = [
  { key: 'player_points', label: 'Points' },
  { key: 'player_rebounds', label: 'Rebounds' },
  { key: 'player_assists', label: 'Assists' },
  { key: 'player_threes', label: '3-Pointers' },
  { key: 'player_points_rebounds_assists', label: 'Pts+Reb+Ast' },
  { key: 'player_blocks', label: 'Blocks' },
  { key: 'player_steals', label: 'Steals' },
  { key: 'player_turnovers', label: 'Turnovers' },
  { key: 'player_double_double', label: 'Double-Double' },
  { key: 'player_triple_double', label: 'Triple-Double' },
];

export const MLB_PROP_MARKETS = [
  { key: 'batter_hits', label: 'Hits' },
  { key: 'batter_total_bases', label: 'Total Bases' },
  { key: 'batter_rbis', label: 'RBIs' },
  { key: 'batter_runs_scored', label: 'Runs Scored' },
  { key: 'batter_home_runs', label: 'Home Runs' },
  { key: 'pitcher_strikeouts', label: 'Strikeouts' },
  { key: 'pitcher_outs', label: 'Pitcher Outs' },
  { key: 'pitcher_earned_runs', label: 'Earned Runs' },
  { key: 'pitcher_hits_allowed', label: 'Hits Allowed' },
  { key: 'pitcher_walks', label: 'Pitcher Walks' },
];

export const NFL_PROP_MARKETS = [
  { key: 'player_pass_yds', label: 'Pass Yards' },
  { key: 'player_pass_tds', label: 'Pass TDs' },
  { key: 'player_pass_attempts', label: 'Pass Attempts' },
  { key: 'player_pass_completions', label: 'Completions' },
  { key: 'player_rush_yds', label: 'Rush Yards' },
  { key: 'player_rush_attempts', label: 'Rush Attempts' },
  { key: 'player_reception_yds', label: 'Receiving Yards' },
  { key: 'player_receptions', label: 'Receptions' },
  { key: 'player_anytime_td', label: 'Anytime TD' },
];

export const NHL_PROP_MARKETS = [
  { key: 'player_points', label: 'Points' },
  { key: 'player_goals', label: 'Goals' },
  { key: 'player_assists', label: 'Assists' },
  { key: 'player_shots_on_goal', label: 'Shots on Goal' },
  { key: 'player_blocked_shots', label: 'Blocked Shots' },
];

export const WNBA_PROP_MARKETS = [
  { key: 'player_points', label: 'Points' },
  { key: 'player_rebounds', label: 'Rebounds' },
  { key: 'player_assists', label: 'Assists' },
  { key: 'player_threes', label: '3-Pointers' },
  { key: 'player_points_rebounds_assists', label: 'Pts+Reb+Ast' },
  { key: 'player_blocks', label: 'Blocks' },
  { key: 'player_steals', label: 'Steals' },
];

export const SOCCER_PROP_MARKETS = [
  { key: 'player_goal_scorer_anytime', label: 'Anytime Scorer' },
  { key: 'player_first_goal_scorer', label: 'First Scorer' },
  { key: 'player_last_goal_scorer', label: 'Last Scorer' },
];

export const getPropMarketsForSport = (sportKey) => {
  if (sportKey === 'basketball_nba') return NBA_PROP_MARKETS;
  if (sportKey === 'basketball_wnba') return WNBA_PROP_MARKETS;
  if (sportKey === 'baseball_mlb') return MLB_PROP_MARKETS;
  if (sportKey === 'americanfootball_nfl') return NFL_PROP_MARKETS;
  if (sportKey === 'icehockey_nhl') return NHL_PROP_MARKETS;
  if (sportKey?.startsWith('soccer_')) return SOCCER_PROP_MARKETS;
  return [];
};

export const getDefaultPropMarket = (sportKey) => {
  if (sportKey === 'basketball_nba') return 'player_points';
  if (sportKey === 'basketball_wnba') return 'player_points';
  if (sportKey === 'baseball_mlb') return 'batter_hits';
  if (sportKey === 'americanfootball_nfl') return 'player_pass_yds';
  if (sportKey === 'icehockey_nhl') return 'player_points';
  if (sportKey?.startsWith('soccer_')) return 'player_goal_scorer_anytime';
  return '';
};

const SPORTSBOOK_ABBREVIATIONS = {
  'DraftKings': 'DK',
  'FanDuel': 'FD',
  'BetMGM': 'MGM',
  'Caesars': 'CZR',
  'Fanatics': 'FAN',
  'PointsBet': 'PB',
  'BetRivers': 'BR',
  'Unibet': 'UNI',
  'William Hill': 'WH',
  'bet365': '365',
};

export const getBookmakerAbbreviation = (bookmakerTitle) => {
  return SPORTSBOOK_ABBREVIATIONS[bookmakerTitle] || bookmakerTitle.substring(0, 3).toUpperCase();
};
